import { observer } from 'mobx-react-lite';
import 'semantic-ui-css/semantic.min.css';
import {
  Header,
  Form,
  Table,
  Button,
  Input,
  Pagination,
  Icon,
} from 'semantic-ui-react';
import React, { useEffect, useState } from 'react';
import { useStore } from '../../app/stores/store';
import { employeeLockedInfo } from '../../app/models/adlData';
import { toast } from 'react-toastify';
function EmployeeUnlock() {
  const { ADLtrackingStore } = useStore();
  const [getLockedEmployee, setLockedEmployeDetails] = useState<
    employeeLockedInfo[]
  >([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [inputValues, setInputValues] = useState<string[]>([]);
  const [buttonsClicked, setButtonsClicked] = useState<boolean[]>([]);
  const [countLockedEmp, setCountLockedEmp] = useState<any>(1);
  const itemPerPage = 20;
  useEffect(() => {
    fetchLockedEmployeeDetails();
    // eslint-disable-next-line
  }, [currentPage]);

  const fetchLockedEmployeeDetails = async () => {
    try {
      const data = await ADLtrackingStore.getLockedEmployeeDetails(
        currentPage,
        itemPerPage,
      );
      setLockedEmployeDetails(data);
      const countLocked = await ADLtrackingStore.numberofLockedEmployee();
      setCountLockedEmp(countLocked);
    } catch (error) {
      toast.error('Error fetching locked employee details:');
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const newInputValues = [...inputValues];
    newInputValues[index] = e.target.value;
    setInputValues(newInputValues);
  };

  const unLockHandler = async (
    employeeLockedInfo: employeeLockedInfo,
    index: number,
  ) => {
    if (!inputValues[index] || inputValues[index].trim() === '') {
      const updatedButtonsClicked = [...buttonsClicked];
      updatedButtonsClicked[index] = true;
      setButtonsClicked(updatedButtonsClicked);
      toast.error('Please enter a valid reason...');
    } else {
      let historyPayLoad: employeeLockedInfo = {
        employee_ID: employeeLockedInfo.employee_ID,
        employeeName: employeeLockedInfo.employeeName,
        currentUnlockTime: employeeLockedInfo.currentUnlockTime,
        idleTime: employeeLockedInfo.idleTime,
        reason: inputValues[index],
      };
      await ADLtrackingStore.unlockEmployee(historyPayLoad);
      fetchLockedEmployeeDetails();
      setInputValues([]);
    }
  };

  return (
    <>
      <div className="title-wise-table">
        <Header>ADL Unlock</Header>
        <Table singleLine>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Employee Id</Table.HeaderCell>
              <Table.HeaderCell>Employee Name</Table.HeaderCell>
              <Table.HeaderCell>
                how many occurrences
                <br />
                in today
              </Table.HeaderCell>
              <Table.HeaderCell>Idle Time</Table.HeaderCell>
              <Table.HeaderCell>Reason</Table.HeaderCell>
              <Table.HeaderCell>Approved</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {getLockedEmployee.map((Items, index) => (
              <Table.Row key={index}>
                <Table.Cell>{Items.employee_ID}</Table.Cell>
                <Table.Cell>{Items.employeeName}</Table.Cell>
                <Table.Cell>{Items.currentUnlockTime}</Table.Cell>
                <Table.Cell>{Items.idleTime}</Table.Cell>
                <Table.Cell>
                  <Form.Field
                    control={Input}
                    placeholder="Please enter valid reason..."
                    required
                    value={inputValues[index] || ''}
                    onChange={(e: any) => {
                      handleInputChange(e, index);
                      const updatedButtonsClicked = [...buttonsClicked];
                      updatedButtonsClicked[index] = false;
                      setButtonsClicked(updatedButtonsClicked);
                    }}
                  />
                  {!inputValues[index] && buttonsClicked[index] && (
                    <div style={{ color: 'red' }}>
                      Please enter a valid reason.
                    </div>
                  )}
                </Table.Cell>
                <Table.Cell>
                  <Button.Group>
                    <Button
                      disabled={buttonsClicked[index]}
                      onClick={() => {
                        unLockHandler(Items, index);
                      }}
                    >
                      <Icon name="lock open" />
                    </Button>
                  </Button.Group>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
        <Pagination
          activePage={currentPage || 1}
          totalPages={Math.ceil(countLockedEmp / itemPerPage)}
          onPageChange={(_event, data) =>
            setCurrentPage(Number(data.activePage) || 1)
          }
        />
      </div>
    </>
  );
}
export default observer(EmployeeUnlock);
